import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePropertyByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Properties_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdatePropertyByIdMutation = { __typename?: 'mutation_root', update_properties_by_pk?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, workspace_id?: any | null, photo_link?: string | null, organization_id: any, warranty_expiration_date?: any | null, warranty_start_date?: any | null, warranty_document_id?: any | null, building_type?: string | null, occupancy_class?: string | null, num_stories?: number | null, num_units?: number | null, construction_type?: string | null, sprinklered?: string | null, year_built?: number | null, expected_device_type?: any | null, created_at?: any | null, updated_at?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null } | null, property_contacts: Array<{ __typename?: 'property_contacts', id: any, name?: string | null, number?: string | null, email?: string | null }>, property_users: Array<{ __typename?: 'user_properties', user?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, profile_photo?: string | null, phone_number?: string | null, role?: string | null, title?: string | null } | null }>, property_documents: Array<{ __typename?: 'property_documents', id: any, name?: string | null, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed?: boolean | null, type?: string | null, description?: string | null, doctrine_doc_id?: string | null, created_at?: any | null }>, installed_products: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string } } }> } | null };


export const UpdatePropertyByIdDocument = gql`
    mutation updatePropertyById($set: properties_set_input, $id: uuid!) {
  update_properties_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    name
    address
    address_id
    standardized_address {
      id
      street_1
      street_2
      city
      state
      postal_code
      country
    }
    premium
    tier_status
    workspace_id
    photo_link
    organization_id
    warranty_expiration_date
    warranty_start_date
    warranty_document_id
    building_type
    occupancy_class
    num_stories
    num_units
    construction_type
    sprinklered
    year_built
    expected_device_type
    created_at
    updated_at
    organization_id
    organization {
      id
      name
      contact_name
      email
    }
    property_contacts {
      id
      name
      number
      email
    }
    property_users {
      user {
        id
        first_name
        last_name
        email
        profile_photo
        phone_number
        role
        title
      }
    }
    property_documents {
      id
      name
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      description
      doctrine_doc_id
      created_at
    }
    installed_products {
      id
      product_id
      property_id
      installation_date
      warranty_expiration_date
      warranty_status
      product_serial
      product {
        id
        name
        description
        sku
        product_category {
          name
          label
        }
        make
        model
        photo_link
      }
    }
  }
}
    `;
export type UpdatePropertyByIdMutationFn = Apollo.MutationFunction<UpdatePropertyByIdMutation, UpdatePropertyByIdMutationVariables>;

/**
 * __useUpdatePropertyByIdMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyByIdMutation, { data, loading, error }] = useUpdatePropertyByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePropertyByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyByIdMutation, UpdatePropertyByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyByIdMutation, UpdatePropertyByIdMutationVariables>(UpdatePropertyByIdDocument, options);
      }
export type UpdatePropertyByIdMutationHookResult = ReturnType<typeof useUpdatePropertyByIdMutation>;
export type UpdatePropertyByIdMutationResult = Apollo.MutationResult<UpdatePropertyByIdMutation>;
export type UpdatePropertyByIdMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyByIdMutation, UpdatePropertyByIdMutationVariables>;